// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"711":"b489c078","1277":"4056a63f","1813":"3b84cb63"}[chunkId] + ".chunk.css";
};